export const ROW_ELEMENTS_MARGIN_PER_COLUMN = 4 * 2
export const ROW_ICON_BUTTON_MARGINS = 7 * 2
export const ROW_ICON_BUTTON_WIDTH = 32
export const ROW_CHECKBOX_WIDTH = 30
export const ROW_CHECKBOX_RIGHT_MARGIN = 14
export const ROW_ELEMENTS_LEFT_MARGIN = 10.5
export const ROW_LEFT_PADDING = 17.5
export const ROW_ICON_BUTTONS_MIN_WIDTH = 180
export const ROW_HEIGHT = 40
